import { render, staticRenderFns } from "./BuscarJugadorTurno.vue?vue&type=template&id=19dd2a1e&scoped=true"
import script from "./BuscarJugadorTurno.vue?vue&type=script&lang=js"
export * from "./BuscarJugadorTurno.vue?vue&type=script&lang=js"
import style0 from "./BuscarJugadorTurno.vue?vue&type=style&index=0&id=19dd2a1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dd2a1e",
  null
  
)

export default component.exports